import { render, staticRenderFns } from "./PhonePreview.vue?vue&type=template&id=1acef3b8&scoped=true"
import script from "./PhonePreview.vue?vue&type=script&lang=js"
export * from "./PhonePreview.vue?vue&type=script&lang=js"
import style0 from "./PhonePreview.vue?vue&type=style&index=0&id=1acef3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acef3b8",
  null
  
)

export default component.exports